import React from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { Notifier } from '../../../../../../system/services/notificationManager';
import { useAuthorizer } from '../../../../../../auth/AuthorizationContext';
import {
  Maybe,
  useClearThermostatUpdateStatusMutation,
} from '../../../../../../../types/generated-types';

interface UpdatePendingProps {
  deviceId?: string | Maybe<string> | undefined | null;
  status: 'submitted' | 'awaiting';
  padding?: number;
}

export function UpdatePending({
  deviceId,
  status = 'submitted',
  padding = 2,
}: UpdatePendingProps) {
  const { can } = useAuthorizer();
  const [clearThermostatUpdateStatus] = useClearThermostatUpdateStatusMutation({
    refetchQueries: ['ThermostatDetail'],
  });

  const handleClearThermostatUpdateStatusHandler = async () => {
    try {
      if (deviceId) {
        await clearThermostatUpdateStatus({
          variables: { deviceId: deviceId || '' },
        });
        Notifier.success('Update status cleared successfully');
      } else {
        Notifier.error('No device id available.');
      }
    } catch (error) {
      Notifier.error('Failed to clear update status');
      console.error('Error clearing update status:', error);
    }
  };

  return (
    <Box
      alignItems={'center'}
      justifyContent={'center'}
      sx={{
        padding: `${padding}px 10px`,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <CircularProgress color={status === 'submitted' ? 'info' : 'success'} />
      {deviceId && can('be', 'super') ? (
        <div onClick={handleClearThermostatUpdateStatusHandler}>
          Click to clear 'awaiting update' status ...
        </div>
      ) : null}
      <div>
        {status === 'submitted'
          ? 'Sending request to device ...'
          : 'Awaiting configuration change confirmation'}
      </div>
    </Box>
  );
}
